import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { type FactoryTypeText } from '@common/types/factory';
import { FactoryComponent } from '@components/helpers/ObjectsText';
import { StringSmall } from '@components/Typography/Typography';
import { Picture } from '@components/ui/Picture/Picture';

import { AppRoute } from '@/common/app/routes';

import css from './styles.module.scss';

interface PlantNavigationItemProps {
  id: string;
  name: string;
  onClose: () => void;
}

const PlantNavigationItem: FC<PlantNavigationItemProps> = ({
  name,
  id,
  onClose,
}) => {
  const { t } = useTranslation();
  const { id: pageId } = useParams();
  const navigate = useNavigate();
  const texts = FactoryComponent(t);

  const onClick = (): void => {
    if (pageId !== name && pageId !== id) {
      navigate(AppRoute.WORKSHOP + `/${id}`);
      onClose();
    }
  };

  return (
    <div onClick={onClick} className={css.plantNavItem}>
      <StringSmall weight="medium" className={css.label}>
        {texts[name as FactoryTypeText].nameFactory}
      </StringSmall>
      <Picture
        className="w-10 h-10 shrink-0"
        img={`/img/builds/workshop-characters/${name}.png`}
        webp={`/img/builds/workshop-characters/${name}.webp`}
        alt={name}
      />
    </div>
  );
};

export { PlantNavigationItem };
